<template>
    <div class="data-wrapper-core">
        <h3>Kerndaten</h3>
        <v-divider></v-divider>
        <h4>Kunden-Name:</h4>
        <p>{{ customers.name }}</p>
        <h4>Beschreibung:</h4>
        <p>{{ customers.description }}</p>
        <h4>Erstelldatum:</h4>
        <p>{{ customers.createdAt }}</p>
        <h4>Kunden-ID:</h4>
        <p>{{ customers._id }}</p>
        <h4>Archiviert:</h4>
        <p>{{ customers.archived }}</p>
        <h4>Inaktiv:</h4>
        <p>{{ customers.inactive }}</p>
        <h4>Gesamtzahl der Leads:</h4>
        <p>{{ customers.leadsCombined }}</p>    
    </div>
</template>

<script>
    export default {
        props: {
            customers: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>